<template>
  <v-container fluid>
    <v-card>
      <v-toolbar>
        <v-icon>cloud_download</v-icon>
        <v-toolbar-title class="font-weight-light"
          >&nbsp;Subdiario de Cobranzas</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)"
            >
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <span class="title">Filtros</span>
        <v-divider></v-divider>
        <v-row dense>
          <v-col cols="6" lg="3">
            <v-autocomplete
              v-model="filtro.empresaId"
              :items="listEmpresas"
              autocomplete="disabled"
              item-text="nombre"
              item-value="id"
              label="Cobranzas de la Empresa"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6" lg="3">
            <v-autocomplete
              v-model="filtro.sucursalId"
              :items="listSucursales"
              autocomplete="disabled"
              item-text="nombre"
              item-value="id"
              label="de la Sucursal"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6" lg="3">
            <v-autocomplete
              v-model="filtro.canalVentaId"
              :items="listCanalesVenta"
              autocomplete="disabled"
              item-text="nombre"
              item-value="id"
              label="del Canal de Venta"
              placeholder="Seleccione uno"
              :menu-props="{ minWidth: '400' }"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6" lg="3">
            <v-autocomplete
              v-model="filtro.productoId"
              :items="listProductos"
              autocomplete="disabled"
              item-text="descripcion"
              item-value="id"
              label="del Producto"
              placeholder="Seleccione uno"
              :menu-props="{ minWidth: '400' }"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="6" lg="3">
            <!---------------------------------------------------- -->
            <!---------------------------------------------------- -->
            <v-autocomplete
              v-model="filtro.cajaId"
              :items="listCajas"
              autocomplete="disabled"
              item-text="descripcion"
              item-value="id"
              label="de la Caja"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"
            >
              <template v-slot:item="{ item }">
                <template>
                  <v-list-item-content>
                    <v-list-item-title
                      v-html="`${item.descripcion}`"
                    ></v-list-item-title>
                    <v-list-item-subtitle
                      v-html="`${item.empresaNombre}`"
                    ></v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </template>
            </v-autocomplete>

            <!---------------------------------------------------- -->
            <!---------------------------------------------------- -->
          </v-col>

          <v-col cols="6" lg="3">
            <v-autocomplete
              v-model="filtro.origenPagoId"
              :items="listOrigenPago"
              autocomplete="disabled"
              item-text="descripcion"
              item-value="id"
              label="Cobranzas Originadas por"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"
            ></v-autocomplete>
          </v-col>

          <!-- <v-col cols ="3">
                        <v-autocomplete v-model="filtro.canalVentaId" :items="listCanalesVenta" autocomplete="disabled"
                            item-text="nombre" item-value="id" label="del Canal de Venta" placeholder="Seleccione uno" :menu-props="{minWidth:'400'}"></v-autocomplete>
                    </v-col>
                    <v-col cols ="3">
                        <v-autocomplete v-model="filtro.productoId" :items="listProductos" autocomplete="disabled"
                            item-text="descripcion" item-value="id" label="del Producto" placeholder="Seleccione uno" :menu-props="{minWidth:'400'}"></v-autocomplete>
                    </v-col> -->
        </v-row>
        <v-row dense>
          <v-col cols="6" lg="3">
            <v-text-field
              v-model="filtro.fechaDesde"
              label="Corabranza Desde"
              type="date"
              prepend-icon="event"
            ></v-text-field>
          </v-col>
          <v-col cols="6" lg="3">
            <v-text-field
              v-model="filtro.fechaHasta"
              label="Corabranza Hasta"
              type="date"
              prepend-icon="event"
            ></v-text-field>
          </v-col>
          <v-col cols="6" lg="3">
            <v-text-field
              v-model="filtro.fechaAplicacionDesde"
              label="Aplicación Desde"
              type="date"
              prepend-icon="event"
            ></v-text-field>
          </v-col>
          <v-col cols="6" lg="3">
            <v-text-field
              v-model="filtro.fechaAplicacionHasta"
              label="Aplicación Hasta"
              type="date"
              prepend-icon="event"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="6" lg="3">
            <v-switch
              v-model="filtro.soloEnEstudio"
              label="Sólo casos en Estudio"
            ></v-switch>
          </v-col>
          <v-col cols="6" lg="3">
            <v-autocomplete
              v-model="filtro.estudioId"
              :items="listEstudios"
              autocomplete="disabled"
              item-text="descripcion"
              item-value="id"
              label="Casos en Estudio"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row dense v-if="!filtro.resumido">
          <v-col cols="10" lg="6">
            <v-radio-group
              v-model="filtro.cartera"
              :mandatory="true"
              label="Incluir Cartera"
              row
            >
              <v-radio value="0">
                <div slot="label">Completa</div>
              </v-radio>
              <v-radio value="1">
                <div slot="label">Propia</div>
              </v-radio>
              <v-radio value="2">
                <div slot="label">Vendida</div>
              </v-radio>
            </v-radio-group>
          </v-col>

          <v-col cols="2" v-if="filtro.cartera == 2">
            <v-autocomplete
              v-model="filtro.ventaCarteraId"
              :items="listVentasCarteraEmpresa"
              autocomplete="disabled"
              item-text="nombre"
              item-value="id"
              label="Cartera Vendida a"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <span class="title">Opciones</span>
        <v-divider></v-divider>
        <v-row dense>
          <v-col cols="6" lg="3">
            <v-switch v-model="filtro.resumido" label="Resumido"></v-switch>
          </v-col>

          <v-col cols="6" lg="3">
            <v-switch
              v-model="filtro.porSucursalCobro"
              label="Por Sucursal de Cobro"
            ></v-switch>
          </v-col>
          <v-col cols="6" lg="2" v-if="!filtro.resumido">
            <v-switch
              v-model="filtro.incluirNotasCredito"
              label="Incluir Quitas"
            ></v-switch>
          </v-col>
          <v-col cols="6" lg="3">
            <v-switch
              v-model="filtro.incluirActivos"
              label="Incluir Créditos Activos"
            ></v-switch>
          </v-col>
          <v-col cols="6" lg="3">
            <v-switch
              v-model="filtro.incluirPrevisionados"
              label="Incluir Créditos Incobrables"
            ></v-switch>
          </v-col>
          <v-col cols="6" lg="3">
            <v-switch
              v-model="filtro.incluirBancoAcreditacion"
              label="Incluir Banco Acreditación"
            ></v-switch>
          </v-col>
          <v-col cols="2" lg="1">
            <v-text-field
              v-model="filtro.separador"
              label="Separador en archivo"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-divider></v-divider>

        <v-row dense v-if="checkCanAccess('ap-reversar-pagos')">
          <v-col cols="2">
            <v-switch
              v-model="filtro.modoAnulacion"
              label="Modo Anulación"
            ></v-switch>
          </v-col>

          <v-col align-self="center">
            <v-btn
              dark
              color="red"
              small
              @click="anularMasivo"
              :disabled="loading"
              v-if="filtro.modoAnulacion"
            >
              Anular Resultado de Selección&nbsp;
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="filtro.modoAnulacion">
          <v-col>
            <v-alert color="warning" dark dense>
              ANTENCIÓN. Este proceso es irrebersible, y anulará TODOS los pagos
              incluidos en la selección. Asegurarse de que los parámetros de
              filtro sean correctos.
            </v-alert>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-btn dark color="green" @click="procesarBase" :disabled="loading">
          Descargar Archivo&nbsp;
          <v-icon>cloud_download</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          dark
          color="green"
          @click="procesarReporte"
          :disabled="loading"
          v-if="!filtro.resumido"
        >
          Generar Reporte&nbsp;
        </v-btn>
      </v-card-actions>
    </v-card>

    <app-loading :loading="loading"></app-loading>
  </v-container>
</template>
<script>
import { http } from '@/axios';
import Vue from 'vue';
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';

export default {
  data() {
    return {
      loading: false,
      filtro: {
        empresaId: 1,
        sucursalId: 0,
        canalVentaId: 0,
        productoId: 0,
        cajaId: 0,
        incluirNotasCredito: false,
        soloEnEstudio: false,
        estudioId: 0,
        cartera: 0,
        ventaCarteraId: '00000000-0000-0000-0000-000000000000',
        fechaDesde: null,
        fechaHasta: null,
        fechaAplicacionDesde: null,
        fechaAplicacionHasta: null,
        porSucursalCobro: true,
        origenPagoId: 0,
        incluirActivos: true,
        incluirPrevisionados: false,
        incluirBancoAcreditacion: false,
        resumido: true,
        separador: ';',
      },
      listEmpresas: [],
      listSucursales: [],
      listCanalesVenta: [],
      listProductos: [],
      listCajas: [],
      listEstudios: [],
      listVentasCartera: [],
      listOrigenPago: [],
    };
  },
  async created() {
    this.loadEmpresas();
    this.loadSucursales();
    this.loadCanalesVenta();
    this.loadProductos();
    this.loadCajas();
    this.loadEstudios();
    this.loadVentasCartera();
    this.loadOrigenesPago();

    this.filtro.fechaDesde = this.$moment()
      .startOf('month')
      .format('YYYY-MM-DD');
    this.filtro.fechaHasta = this.$moment(new Date()).format('YYYY-MM-DD');
  },
  computed: {
    ...mapGetters([
      'activeTask',
      'getActionFromLink',
      'user',
      'closeRelatedTasks',
      'checkCanAccess',
    ]),
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
    listVentasCarteraEmpresa: function () {
      if (!this.listVentasCartera) return null;
      return this.listVentasCartera.filter(
        (v) => v.empresaId == this.filtro.empresaId
      );
    },
  },
  methods: {
    ...mapMutations([
      'setActiveTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
      'setReporteActivo',
    ]),
    ...mapActions(['setStatusTareaFrecuente']),
    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get(
          'empresas/list/porusuario?usuarioId=' + this.user.id
        );

        this.listEmpresas = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSucursales() {
      this.loading = true;
      try {
        var result = await http.get(
          'sucursales/list/porusuario?usuarioId=' + this.user.id
        );

        this.listSucursales = result.list;

        this.listSucursales.unshift({ id: 0, nombre: '(Todas)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCajas() {
      this.listCajas = [];
      this.loading = true;
      try {
        var result = await http.get(
          'cajas/disponiblesporusuario?login=' + this.user.login
        );
        this.listCajas = result.list;
        this.listCajas.unshift({ id: 0, descripcion: '(Cualquiera)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCanalesVenta() {
      this.loading = true;
      try {
        var result = await http.get(
          'canalesventa/habilitadosparausuario?usuarioId=' + this.user.id
        );

        this.listCanalesVenta = result.list;
        this.listCanalesVenta.unshift({ id: 0, nombre: '(Todos)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadProductos() {
      this.loading = true;
      try {
        var result = await http.get('productos/');

        this.listProductos = result.list;
        this.listProductos.unshift({ id: 0, descripcion: '(Todos)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadEstudios() {
      this.loading = true;
      try {
        var result = await http.get('estudiosexternos'); //traigo los estudios

        this.listEstudios = result.list;
        this.listEstudios.unshift({ id: 0, descripcion: '(Cualquiera)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadVentasCartera() {
      this.loading = true;
      try {
        var result = await http.get('ventasCartera?estadoId=3&limit=999'); //traigo las ventas de cartera

        this.listVentasCartera = result.list;
        this.listVentasCartera.unshift({
          id: '00000000-0000-0000-0000-000000000000',
          nombre: '(Indistinto)',
          empresaId: 1,
        });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadOrigenesPago() {
      this.loading = true;
      try {
        var result = await http.get('tiposorigenpago/');

        this.listOrigenPago = result.list;

        this.listOrigenPago.unshift({ id: 0, descripcion: '(Indistinto)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    validar() {
      if (this.filtro.empresaId === 0) {
        this.alertWarning('Debe seleccionar una Empresa.');
        return false;
      }

      if (!this.filtro.fechaDesde) {
        this.alertWarning('Debe ingresar la Fecha de Cobranza Desde.');
        return false;
      }

      if (!this.filtro.fechaHasta) {
        this.alertWarning('Debe ingresar la Fecha de Cobranza Hasta.');
        return false;
      }

      return true;
    },
    async procesarReporte() {
      // validaciones
      if (!this.validar()) {
        return;
      }

      var self = this;

      try {
        self.loading = true;

        let params = [];
        params.push({
          Version: this.$store.state.version,
          EmpresaId: this.filtro.empresaId,
          ProductoId: this.filtro.productoId,
          SucursalId: this.filtro.sucursalId,
          CanalVentaId: this.filtro.canalVentaId,
          CajaId: this.filtro.cajaId,
          IncluirNotasCredito: this.filtro.incluirNotasCredito,
          SoloEnEstudio: this.filtro.soloEnEstudio,
          Estudios: this.filtro.estudioId,
          Cartera: this.filtro.cartera,
          VentaCarteraId: this.filtro.ventaCarteraId,
          FechaDesde: this.filtro.fechaDesde,
          FechaHasta: this.filtro.fechaHasta,
          FechaAplicacionDesde: this.filtro.fechaAplicacionDesde,
          FechaAplicacionHasta: this.filtro.fechaAplicacionHasta,
          PorSucursalCobro: this.filtro.porSucursalCobro,
          IncluirActivos: true,
          IncluirPrevisionados: false,
          EmpresaNombre: this.listEmpresas.find(
            (i) => i.id == this.filtro.empresaId
          ).nombre,
          CanalVenta: this.listCanalesVenta.find(
            (i) => i.id == this.filtro.canalVentaId
          ).nombre,
          Sucursal: this.listSucursales.find(
            (i) => i.id == this.filtro.sucursalId
          ).nombre,
          VentaCartera: this.listVentasCartera.find(
            (i) => i.id == this.filtro.ventaCarteraId
          ).nombre,
        });

        this.setReporteActivo({
          reporte: 'Subdiario de Cobranzas.trdp',
          params: params,
        });
        window.open('/report-viewer');
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },
    async anularMasivo() {
      // validaciones
      if (!this.validar()) {
        return;
      }

      var self = this;

      try {
        self.loading = true;

        this.filtro.estudios = this.filtro.estudioId;

        await http
          .put(
            'businesscore/anularmasivo',
            JSON.stringify({ parametros: this.filtro })
          )
          .then(() => {
            self.alertSuccess('Se procesó la Anulación correctamente.');
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },
    async procesarBase() {
      // validaciones
      if (!this.validar()) {
        return;
      }

      var self = this;

      try {
        self.loading = true;

        this.filtro.estudios = this.filtro.estudioId;

        await http
          .post(
            'filegeneration/subdiariocobranzas',
            JSON.stringify({ parametros: this.filtro })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess(
                'Se generó correctamente el archivo. Aguarde unos instantese mientras se descarga el archivo...'
              );

              self.loading = true;
              self.downloadFile(resp, 'SubdiarioCobranzas.csv');
              self.loading = false;
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },
    async downloadFile(file, renameTo) {
      //convierto el string del path a base64 para poder mandarlo
      let base64String = '';
      base64String = btoa(file.fullPath);

      http
        .get('filemanagement/getfilebypath/' + base64String)
        .then((resp) => {
          let dataType = '';
          switch (resp.extension) {
            case '.doc':
            case '.docx':
            case '.DOC':
            case '.DOCX':
              dataType = 'data:application/vnd.ms-word';
              break;
            case '.pdf':
            case '.PDF':
              dataType = 'data:application/pdf';
          }

          //necesito hacer esto del arrayBuffer para que despues se pueda hacer el blob
          var arrayBuffer = this.base64ToArrayBuffer(resp.file);
          this.saveByteArray(renameTo, arrayBuffer, dataType);
        })
        .catch((e) => this.alertError(e));
    },
    base64ToArrayBuffer(base64) {
      var binaryString = atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    saveByteArray(fileName, byteArrayBuffer, dataType) {
      var blob = new Blob([byteArrayBuffer], { type: dataType });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
  },
};
</script>
